/**
 * Client-side image resizer.
 * Reads a File, downscales to maxDim (longest side) and returns a JPEG data URL.
 */
export const fileToResizedDataUrl = (file, maxDim = 1200, quality = 0.85) =>
  new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('Geen bestand geselecteerd'));
      return;
    }
    if (!file.type.startsWith('image/')) {
      reject(new Error('Bestand is geen afbeelding'));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error || new Error('Kon bestand niet lezen'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('Kon afbeelding niet laden'));
      img.onload = () => {
        const { width, height } = img;
        const scale = Math.min(1, maxDim / Math.max(width, height));
        const w = Math.round(width * scale);
        const h = Math.round(height * scale);
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        try {
          const dataUrl = canvas.toDataURL('image/jpeg', quality);
          resolve(dataUrl);
        } catch (e) {
          reject(e);
        }
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
